// extracted by mini-css-extract-plugin
export var acitonButtons = "_hg-0";
export var additionalIcon = "_hg-f";
export var block = "_hg-1";
export var blockContent = "_hg-7";
export var blockDescription = "_hg-8";
export var blockIcon = "_hg-9";
export var blockTitle = "_hg-6";
export var border = "_hg-a";
export var center = "_hg-l";
export var edge = "_hg-b";
export var edgeLabel = "_hg-c";
export var edgePath = "_hg-d";
export var error = "_hg-e";
export var flowchart = "_hg-g";
export var flowchartContent = "_hg-h";
export var highlighted = "_hg-3";
export var hover = "_hg-4";
export var icon = "_hg-i";
export var left = "_hg-m";
export var navButton = "_hg-j";
export var navButtons = "_hg-k";
export var right = "_hg-n";
export var selected = "_hg-2";
export var small = "_hg-5";